/** Interpolación de cámara para el modo presentación. */
import type { Camera } from '../state/store.ts'

/** Fracción de la distancia que se recorre en cada cuadro (0-1). */
export const CHASE = 0.28
/** A partir de aquí la cámara se considera "en su sitio", en unidades de mundo. */
const CLOSE_ENOUGH = 0.4
/** Y esto para el zoom, en proporción (0.2 %). */
const ZOOM_CLOSE_ENOUGH = 0.002

/**
 * Da el siguiente paso hacia la cámara del que presenta.
 *
 * El desplazamiento se interpola derecho y el zoom en escala logarítmica: el
 * zoom es multiplicativo (de 25 % a 100 % hay el mismo "camino" que de 100 % a
 * 400 %), así que interpolarlo en línea recta da un tirón al final.
 *
 * Devuelve `done: true` cuando ya se llegó, para poder parar el bucle.
 */
export function chaseCamera(current: Camera, target: Camera, rate = CHASE): { camera: Camera; done: boolean } {
  const dx = target.x - current.x
  const dy = target.y - current.y
  const ratio = current.z > 0 ? target.z / current.z : 1

  const done =
    Math.abs(dx) < CLOSE_ENOUGH &&
    Math.abs(dy) < CLOSE_ENOUGH &&
    Math.abs(ratio - 1) < ZOOM_CLOSE_ENOUGH

  if (done) return { camera: { ...target }, done: true }

  return {
    camera: {
      x: current.x + dx * rate,
      y: current.y + dy * rate,
      z: current.z * Math.pow(ratio, rate),
    },
    done: false,
  }
}
